import React from "react";
import CText from "../Components/CText";
import { AiOutlineCopyrightCircle } from "react-icons/ai";
import { BsEmojiSmile } from "react-icons/bs";
import {
  FaLinkedin,
  FaGithub,
  FaWhatsapp,
  FaRegEnvelope,
} from "react-icons/fa";
function Botttombar() {
  const number = +923342150724;
  const email = "a.ebrahim360@gmail.com";
  const text = `Hello Abdullah! I am contacting you through your portfolio, let me know your availability for further discussion. `;

  const Mailto = ({ email, subject, body, children }) => {
    return (
      <a
        href={`mailto:${email}?subject=${
          encodeURIComponent(subject) || ""
        }&body=${encodeURIComponent(body) || ""}`}
      >
        {children}
      </a>
    );
  };

  return (
    <div className="BottombarSection">
      <div className="midBar">
        <CText
          className="cw align-content-center subHeading"
          fontSize="2rem"
          text={
            <p>
              Let's Connect and build amazing things together! <BsEmojiSmile />{" "}
            </p>
          }
        />
        <div className="logosSection mt-3">
          <a target="_blank" href={`https://www.linkedin.com/in/ibrahehem/`}>
            <FaLinkedin color="white" size="40px" />
          </a>
          <a target="_blank" href={`https://github.com/ibra360`}>
            <FaGithub color="white" size="40px" />
          </a>
          <Mailto email={email} subject="Hello & Welcome" body={text}>
            <FaRegEnvelope color="white" size="40px" />
          </Mailto>
          <a target="_blank" href={`https://wa.me/${number}?text=${text}`}>
            <FaWhatsapp color="white" size="40px" />
          </a>
        </div>
      </div>
      {/* <div className="hireMeContainer ">
        <CText
          className="cw align-content-center w-75"
          fontSize="1.5rem"
          text={
            <p>
              Interested in working together? We should queue up a time to chat.
              I’ll buy the coffee.
            </p>
          }
        />
        <button className="ContactUs ml-5" color="primary" outline>
          primary
        </button>
      </div> */}
      <CText
        className="cw my-5"
        fontSize="1.8rem"
        text="Living, learning, & leveling up one day at a time."
      />
      <img
        width="150px "
        src="https://www.freepnglogos.com/uploads/pen/pen-ink-hand-vector-graphic-8.png"
      />
      <CText
        className="cw my-4"
        fontSize="1rem"
        text={
          <p>
            Handcrafted by me{" "}
            <AiOutlineCopyrightCircle size={25} color="white" />{" "}
            twentytwentythree.
          </p>
        }
      />
    </div>
  );
}

export default Botttombar;
